import React, { useEffect, useMemo, useState } from 'react'
import { observer, useStore } from '@/hooks/storeHooks'
import { useSearchParams } from 'react-router-dom'
import st from '../topicSubject/index.scss'
import cn from 'classnames'

export default observer(function ({
    title,
    totalPoints,
    difficulty,
    questionNum,
    fullMark,
    elapsedTime,
}) {
    const [ show, setShow ] = useState(true)

    useEffect(() => {
        const id = setTimeout(() => setShow(false), 2000)
        return () => clearTimeout(id)
    })
    const [params] = useSearchParams()
    return (
        <div className={st['newTopScorebox']}>
            <div className={st['titleBox']}>
                <div className={st['newTitle']}>{title}</div>
                <div className={st['tips']}>
                    <div className={st['tipIco']}>
                        {false ?
                            <img src="https://osscdn.zhongheschool.com/p3/img_ico/intelligence.png" alt=""/>
                            :
                            <img src="https://osscdn.zhongheschool.com/zhuma/anserTips.png" alt=""/>
                        }
                    </div>
                    <div className={st['tipTxt']} onMouseEnter={() => setShow(true)} onMouseLeave={() => setShow(false)}>{false ? '智能打分提示' : '打分提示'}</div>

                            {/* {false && params.get('exerciseType') !== 'wanren' ?
                            <div className='positionTips'>
                                <div className='positionTipsIco'><img src="https://osscdn.zhongheschool.com/zhuma/scoreHorn.png" alt=""/></div>
                                <div className='t'>本次练习中，客观题满分共计 199 分</div>
                                <div className='t'>本次客观题答对 100 分，答错 10 分，未答 19 分</div>
                            </div>
                            : true ? */}
                            {show && <div className={st['positionTips']}>
                                <div className={st['positionTipsIco']}><img src="https://osscdn.zhongheschool.com/zhuma/scoreHorn.png" alt=""/></div>
                                {/*<div className='tipsTit'>
                                    <div className='intelligenceico'>
                                        <img src="https://osscdn.zhongheschool.com/p3/img_ico/intelligence.png" alt=""/>
                                    </div>
                                    智能打分提示
                                </div>*/}
                                {/* <div className={st['t']}>本次练习中，满分共计{fullMark}分</div>
                                <div className={st['t']}>有【字段缺失】问参与智能打分，总分为{fullMark}分，您获得<span className='color'>{totalPoints}</span>分</div>
                                <div className={st['t']}>有【字段缺失】问不参与智能打分,总分为{fullMark}分</div> */}
                                <div className={st['t']}>本套测试卷采取电脑智能打分，而非人工批阅，分数仅供参考，打分规则仅适用于本次模拟测试。</div>
                                <div className={st['t']}>选做题得分情况以考生实际选择和作答情况为主。</div>
                                <div className={st['t']}>若未进行选择而作答了两道题，系统只会识别第五题的分数计入总分。</div>
                                <div className={st['t']}>也请考生注意后续依据规则严谨作答。</div>
                            </div>}
                            {/* : false ?
                            <div className='positionTips'>
                                <div className='positionTipsIco'><img src="https://osscdn.zhongheschool.com/zhuma/scoreHorn.png" alt=""/></div>
                                <div className='t'>客观题满分共计 11 分,答对 11 分,答错 112 分,未答 23 分</div>
                                <div className='t'>主观题满分共计 22 分，有 22 问参与智能打分</div>
                                <div className='t'>总分为 33 分,您获得 33 分</div>
                                <div className='t'>有 33 问不参与智能打分,总分为 33 分</div>
                            </div> :''}     */}
                </div>
            </div>
            <div className={st['fullMarkBox']}>
                <div className={cn([st['score'],st['numbox']])}>
                    <div className={st['prpo']}>
                        得分
                    </div>
                    <div className={cn([st['proportion'],st['solid']])}>
                        <span>{totalPoints}</span>
                        <span className={st['ft']}>/{fullMark}</span>
                    </div>
                </div>
                {/* answerType != '0'  */}
                { true ?<div className={cn([st['question'],st['numbox']])}>
                    <div className={st['prpo']}>
                        题量：
                    </div>
                    <div className={cn([st['proportion'],st['solid']])}>
                        <span>{questionNum}</span>
                    </div>
                </div>:""}

                <div className={cn([st['difficulty'],st['numbox']])}>
                    <div className={st['prpo']}>
                        难度：
                    </div>
                    <div className={cn([st['proportion'],st['solid']])}>
                        <span>{difficulty}</span>
                    </div>
                </div>


                <div className={cn(st['time'],st['numbox'])}>
                <div className={st['prpo']}>
                        耗时：
                    </div>
                    <div className={cn([st['proportion'],st['solid']])}>
                        <span>{`${parseInt((elapsedTime/1000)/60)}'${parseInt((elapsedTime/1000)%60)}"`}</span>
                    </div>

                </div>
            </div>
        </div>
    )
})
